// Ruta sugerida: src/components/ImageResizer.jsx

import React, { useEffect, useRef, useState } from 'react';

export const ImageResizer = ({
  imageUrl,
  maxWidth = 800,
  maxHeight = 600,
  altText = 'Imagen redimensionada',
  className = '',
}) => {
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    setLoading(true);
    setError(null);

    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      let width = img.width;
      let height = img.height;

      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
      }

      canvas.width = width;
      canvas.height = height;

      ctx.clearRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);
      setLoading(false);
    };

    img.onerror = () => {
      setError('No se pudo cargar la imagen desde la URL proporcionada.');
      setLoading(false);
    };

    img.src = imageUrl;
  }, [imageUrl, maxWidth, maxHeight]);

  return (
    <div className={`image-resizer-container ${className}`}>
      {loading && <p>Cargando y redimensionando imagen...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <canvas
        ref={canvasRef}
        aria-label={altText}
        style={{ display: loading || error ? 'none' : 'block', maxWidth: '100%', height: 'auto' }}
      />
    </div>
  );
};